var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) typeof console !== "undefined" && console.warn && console.warn(getInvalidSingletonVersionMessage(key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	typeof console !== "undefined" && console.warn && console.warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	43196: () => (loadSingletonVersionCheckFallback("default", "rxjs", [1,6,5,3], () => (Promise.all([__webpack_require__.e(5967), __webpack_require__.e(765)]).then(() => (() => (__webpack_require__(/*! rxjs */ 765))))))),
	60280: () => (loadSingletonVersionCheckFallback("default", "rxjs/operators", [1,6,5,3], () => (Promise.all([__webpack_require__.e(5967), __webpack_require__.e(397)]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 30397))))))),
	78846: () => (loadSingletonVersionCheckFallback("default", "@angular/core", [4,12,0,0], () => (Promise.all([__webpack_require__.e(7553), __webpack_require__.e(7716)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 37716))))))),
	99796: () => (loadFallback("default", "@angular/common", () => (__webpack_require__.e(8583).then(() => (() => (__webpack_require__(/*! @angular/common */ 38583))))))),
	16146: () => (loadSingletonVersionCheckFallback("default", "@angular/common", [4,12,0,0], () => (__webpack_require__.e(8583).then(() => (() => (__webpack_require__(/*! @angular/common */ 38583))))))),
	18639: () => (loadFallback("default", "rxjs", () => (Promise.all([__webpack_require__.e(5967), __webpack_require__.e(765)]).then(() => (() => (__webpack_require__(/*! rxjs */ 765))))))),
	26407: () => (loadSingletonVersionCheckFallback("default", "@angular/common/http", [4,12,0,0], () => (Promise.all([__webpack_require__.e(7553), __webpack_require__.e(1841)]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 91841))))))),
	27525: () => (loadFallback("default", "rxjs/operators", () => (Promise.all([__webpack_require__.e(5967), __webpack_require__.e(397)]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 30397))))))),
	28844: () => (loadFallback("default", "@angular/router", () => (Promise.all([__webpack_require__.e(7553), __webpack_require__.e(9895)]).then(() => (() => (__webpack_require__(/*! @angular/router */ 39895))))))),
	3586: () => (loadSingletonVersionCheckFallback("default", "rxjs", [,[1,7,0,0],[1,6,5,3],1], () => (Promise.all([__webpack_require__.e(5967), __webpack_require__.e(765)]).then(() => (() => (__webpack_require__(/*! rxjs */ 765))))))),
	81955: () => (loadSingletonVersionCheckFallback("default", "rxjs/operators", [,[1,7,0,0],[1,6,5,3],1], () => (Promise.all([__webpack_require__.e(5967), __webpack_require__.e(397)]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 30397))))))),
	73232: () => (loadSingletonVersionCheckFallback("default", "@ngrx/store", [4,12,5,1], () => (Promise.all([__webpack_require__.e(7851), __webpack_require__.e(702), __webpack_require__.e(6710)]).then(() => (() => (__webpack_require__(/*! @ngrx/store */ 86710))))))),
	20702: () => (loadSingletonVersionCheckFallback("default", "@angular/core", [1,12,0,0], () => (Promise.all([__webpack_require__.e(7553), __webpack_require__.e(7716)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 37716))))))),
	54277: () => (loadSingletonVersionCheckFallback("default", "rxjs/operators", [0,6,5,3], () => (Promise.all([__webpack_require__.e(5967), __webpack_require__.e(397)]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 30397))))))),
	85635: () => (loadSingletonVersionCheckFallback("default", "@angular/core", [0,10,0,0], () => (Promise.all([__webpack_require__.e(7553), __webpack_require__.e(7716)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 37716))))))),
	93456: () => (loadSingletonVersionCheckFallback("default", "rxjs", [0,6,5,3], () => (Promise.all([__webpack_require__.e(5967), __webpack_require__.e(765)]).then(() => (() => (__webpack_require__(/*! rxjs */ 765))))))),
	3485: () => (loadSingletonVersionCheckFallback("default", "apollo-client", [1,2,3,4], () => (Promise.all([__webpack_require__.e(2716), __webpack_require__.e(1667)]).then(() => (() => (__webpack_require__(/*! apollo-client */ 21667))))))),
	17188: () => (loadSingletonVersionCheckFallback("default", "rxjs/operators", [1,6,0,0], () => (Promise.all([__webpack_require__.e(5967), __webpack_require__.e(397)]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 30397))))))),
	60239: () => (loadSingletonVersionCheckFallback("default", "@angular/core", [,[1,10,0,0],[1,9,0,0],[1,8,0,0],[1,7,0,0],[1,6,1,0],1,1,1,1], () => (Promise.all([__webpack_require__.e(7553), __webpack_require__.e(7716)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 37716))))))),
	82198: () => (loadSingletonVersionCheckFallback("default", "rxjs", [1,6,0,0], () => (Promise.all([__webpack_require__.e(5967), __webpack_require__.e(765)]).then(() => (() => (__webpack_require__(/*! rxjs */ 765)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"550": [
		3485,
		17188,
		60239,
		82198
	],
	"702": [
		20702
	],
	"1841": [
		99796
	],
	"3232": [
		73232
	],
	"6146": [
		16146
	],
	"6765": [
		18639,
		26407
	],
	"6902": [
		27525,
		28844
	],
	"7553": [
		43196,
		60280
	],
	"7851": [
		3586,
		81955
	],
	"8846": [
		78846
	],
	"9790": [
		54277,
		85635,
		93456
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory).catch(onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}